import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { Box, Button } from "@mui/material";
import DefaultProfileImage from "./DefaultProfileImage";
import ProfilePictureModal from "./ProfilePictureModal";
import { useTranslation } from "react-i18next";

const largeScreenImageSize = 200;
const smallScreenImageSize = 150;

const useStyles = makeStyles(theme => ({
  editButton: {
    marginTop: theme.spacing(2)
  },
  profileImage: {
    maxWidth: largeScreenImageSize,
    border: `solid 1px ${theme.palette.secondary[300]}`,
    [theme.breakpoints.down("md")]: {
      maxWidth: smallScreenImageSize
    }
  }
}));

function getInitial(name) {
  return name ? name.trim().charAt(0) : "";
}

export default function ProfilePicture(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    onApply,
    imageSrc,
    firstName,
    lastName,
    profilePictureContentType
  } = props;

  const [
    profilePictureDialogOpen,
    setProfilePictureDialogOpen
  ] = React.useState(false);

  function handleEditProfilePhotoClick() {
    setProfilePictureDialogOpen(true);
  }

  function handleProfilePictureModalClose() {
    setProfilePictureDialogOpen(false);
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={t("profile.profile")}
          className={classes.profileImage}
        />
      ) : (
        <Box
          width={{ xs: smallScreenImageSize, md: largeScreenImageSize }}
          height={{ xs: smallScreenImageSize, md: largeScreenImageSize }}
        >
          <DefaultProfileImage
            firstInitial={getInitial(firstName)}
            lastInitial={getInitial(lastName)}
          />
        </Box>
      )}
      <Button
        className={classes.editButton}
        color="primary"
        variant="text"
        onClick={handleEditProfilePhotoClick}
      >
        {t("profile.editProfilePicture")}
      </Button>
      <ProfilePictureModal
        profilePicture={imageSrc}
        profilePictureContentType={profilePictureContentType}
        onClose={handleProfilePictureModalClose}
        open={profilePictureDialogOpen}
        onApply={onApply}
      />
    </Box>
  );
}

ProfilePicture.propTypes = {
  onApply: PropTypes.func,
  imageSrc: PropTypes.any,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePictureContentType: PropTypes.any
};
